import { Pipe, PipeTransform } from '@angular/core';
import { NullableString } from '@models/app.models';

@Pipe({ name: 'requiredField', standalone: true })
export class RequiredFieldPipe implements PipeTransform {
  transform(value: NullableString): string {
    if (!value) {
      return '';
    }
    return `${value} *`;
  }
}
